<template>
  <div v-loading="loading" element-loading-background="var(--theme-panel)" class="agreement-content" :aria-busy="loading">
    <p v-if="failed" class="agreement-error" role="alert">配资合同加载失败 <el-button type="text" @click="load">重试</el-button></p>
    <!-- 条款沿用 H5 pagesB/my/peiziPage.vue，仅调整 PC 展示样式。 -->
    <article v-else-if="sysconfig && myUserInfo && info" class="agreement-text">
        <div>
        <p>甲方: <span>{{sysconfig.site.company}}</span></p>
        <p>乙方: <span>{{myUserInfo.real_name}}</span></p>
        <p>就乙方在甲方<span>{{sysconfig.site.company}}</span>融资达成以下协议：</p>
        <p>合作期自
        <span>{{detailObj.atime+'_y' | timeFilter}}</span>年
        <span>{{detailObj.atime+'_m' | timeFilter}}</span>月
        <span>{{detailObj.atime+'_d' | timeFilter}}</span>日起，
        至<span>{{detailObj.etime+'_y' | timeFilter}}</span>年
        <span>{{detailObj.etime+'_m' | timeFilter}}</span>月
        <span>{{detailObj.etime+'_d' | timeFilter}}</span>日止。
        </p>
        </div>
        <div>
        <div>
        一.合作期内，账户盈利全部属于乙方所有，同样，乙方承担全部交易风险（包括买卖股票交易亏损，停牌或摘牌亏损等），甲方提供资金给乙方使用，但不承担交易亏损。交易中如遇到极端行情造成甲方资金亏损，甲方承诺穿仓免责。为确保甲方账户于资金安全，乙方需缴一定比例的风险保证金。本账户甲方原始资金（
        <span>{{numToWord(detailObj.funding?detailObj.funding:'')}}</span>）大写，（即<span v-if="mk == 0">人民币</span>
        <span v-if="mk == 1">港币</span>
        <span v-if="mk == 2">美元</span>
        <span>{{detailObj.funding?detailObj.funding:''}}</span> ），乙方原始资金（
        <span>{{numToWord(deposit)}}</span>）大写，（即<span v-if="mk == 0">人民币</span>
        <span v-if="mk == 1">港币</span>
        <span v-if="mk == 2">美元</span>
        <span>{{deposit}}</span>）作为风险保证金。如乙方交易产生亏损，不超过乙方缴纳的风险保证金的，从风险保证金中扣除，超过风险保证金的，甲方承诺乙方免责
        </div>
        <div>
        二.乙方
        <span>{{detailObj.day_type}}</span>向甲方支付甲方出资额的
        <span>{{detailObj.ratio}}</span>%（即
        <span v-if="mk == 0">人民币</span>
        <span v-if="mk == 1">港币</span>
        <span v-if="mk == 2">美元</span>
        <span>{{managementFee}}</span>）作为综合管理费，管理费于
        <span>{{detailObj.etime+'_y' | timeFilter}}</span>年
        <span>{{detailObj.etime+'_m' | timeFilter}}</span>月
        <span>{{detailObj.etime+'_d' | timeFilter}}</span>日
        <span>{{ showTime }}</span>
        从账户余额自动扣除，如乙方账户余额欠费，3个交易日未补足欠费，甲方有权对股票做平仓处理，并回收资金。因停牌乙方可以选择支付管理费继续持有，或是由平台回收标的。
        <br />
        </div>
        <div>
        三.甲方在收到乙方支付的风险保证金及综合管理费后，甲方券商主账户派发资金给乙方操作。账户交付后至合作终止日前，上述股票交易账户由乙方独立操作，甲方仅按照本协议约定的原则对该账户进行风险监控与管理。
        <br />
        </div>
        <div v-if="mk < 2">
        四.乙方交易操作所发生的印花税，手续费等由券商从股票交易账户代扣，由乙方承担。
        <br />
        </div>
        <div v-if="mk == 2">
        四.乙方交易操作所发生的，手续费等由券商从股票交易账户代扣，由乙方承担。
        <br />
        </div>
        <div>
        五.甲方指定第三方托管银行收款账户作为资金调拨专用账户，乙方据此向甲方缴纳风险保证金或追加保证金，甲方据此向乙方划拨交易盈利或退还风险保证金。
        <br />
        </div>
        <div>
        六.在交易过程中，乙方应严格遵守下列交易规定，并接受甲方及其风险监控人员按照下列风险控制原则处置交易风险：
        <br />
        </div>
        <div v-if="mk == 0">
        1.乙方的投资范围为A股和上海A股主板和中小板市场，乙方不得买入ST,*ST股票，上市30个交易日以内的新股，权证类可以T+0交易的股票，不得购买价格低于
        <span>{{trade_dj}}</span>元的股票，不得进行坐庄，对敲，接盘，大宗交易，内幕信息等违反股票交易法律法规及证券公司规定的交易。
        <br />
        </div>
        <div v-if="mk == 1">
        1.乙方的投资范围（港股）不得购买价格低于
        <span>{{trade_dj}}</span>元的股票，不得进行坐庄，对敲，接盘，大宗交易，内幕信息等违反股票交易法律法规及证券公司规定的交易
        <br />
        </div>
        <div v-if="mk == 2">
        1.乙方的投资范围（美股）不得购买价格低于
        <span>{{trade_dj}}</span>元的股票，不得进行坐庄，对敲，接盘，大宗交易，内幕信息等违反股票交易法律法规及证券公司规定的交易。
        <br />
        </div>
        <div>
        2.在合作期间，乙方须注重风险控制，乙方必须保持合约账户资产在平仓线以上（合约总值=持仓市值+可用余额+买入冻结），否则甲方有权做平仓处理。乙方亏损额达到风险保证金
        <span>{{loss_warn_ratio}}</span>%时触及预警线，亏损额达到风险保证金
        <span>
        {{(loss_close_ratio)}}</span>%时触及平仓线。如平仓后股价反弹回升，甲方不承担责任。
        </div>
        <div>
        七.甲方在任何时候无权对乙方的融资账户进行密码修改操作，如乙方忘记密码需要甲方提供技术支持，需提交申请。
        <br />
        </div>
        <div>
        八.如乙方因自身原因决定提前终止融资合约，已收取的管理费不予以退还。
        <br />
        </div>
        <div>
        九.甲方应对乙方的交易情况予以保密，不得借风险控制工作之便仿照乙方的交易进行买卖操作或向第三方透漏乙方的交易情况。
        <br />
        </div>
        <div>
        十.本协议可通过QQ，微信或电子邮件进行身份确认以后签订合同。
        <br />
        </div>
        <div>
        十一.融资账户到期后，乙方可选择清仓结算该账户，或支付延期管理费继续进行交易操作。
        <br />
        </div>
        <div>
        十二.本协议在乙方支付风险保证金以后至甲方退还风险保证金之前有效，如乙方清仓结算，提取全部账户资金，甲方回收融资资金后，协议解除。
        <br />
        </div>
        <div>
        十三.本协议适用于中华人民共和国法律。因本协议引起的争议纠纷，双方可友好协商解决，协议不成的，可向甲方所在地人民法院起诉。
        </div>
        </div>
        <div class="agreement-signatures">
        <div class="agreement-signature-row">
        <div class="agreement-company-signature">
        <img v-if="stampUrl" :src="stampUrl" class="company-stamp" alt="公司印章" />
        <p>甲方: <span>{{sysconfig.site.company}}</span></p>
        </div>
        <div class="agreement-user-signature">
        <p>乙&nbsp;&nbsp;&nbsp;&nbsp;方&nbsp;: <span>{{myUserInfo.real_name}}</span></p>
        <p>联系电话: <span>{{myUserInfo.mobile}}</span></p>
        <p>签订时间: <span>{{detailObj.ctime | timeFilter}}</span></p>
        </div>
        </div>
        </div>
    </article>
  </div>
</template>
<script>
import { apiConfig, apiUserInfo } from '@/utils/requestapis'
import { agreementDetail, agreementDate, chineseAmount } from './contractAgreement'
import { resourceUrl } from '@/utils/realmName'
export default {
  props: { market: String, info: Object },
  data: () => ({ loading: false, failed: false, sysconfig: null, myUserInfo: null, sequence: 0 }),
  computed: {
    mk() { return this.market === 'us' ? 2 : this.market === 'hk' ? 1 : 0 },
    detailObj() { return agreementDetail(this.market, this.info || {}) },
    deposit() { return this.detailObj.totalDeposit },
    showTime() { if (this.mk !== 2) return this.mk === 1 ? '15:45' : '14:45'; const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', timeZoneName: 'short' }).formatToParts(new Date()); return parts.some(part => part.type === 'timeZoneName' && part.value === 'EDT') ? '03:45' : '04:45' },
    managementFee() { const d = this.detailObj; return Number.isFinite(Number(d.funding)) && Number.isFinite(Number(d.ratio)) ? (Number(d.funding) * Number(d.ratio) / 100).toFixed(2) : '--' },
    trade_dj() { const trade = this.sysconfig.trade || {}; return trade[this.mk === 2 ? 'us_trade_dj' : this.mk === 1 ? 'hk_trade_dj' : 'trade_dj'] == null ? '--' : trade[this.mk === 2 ? 'us_trade_dj' : this.mk === 1 ? 'hk_trade_dj' : 'trade_dj'] },
    loss_warn_ratio() { return this.lossRatio('warn') },
    loss_close_ratio() { return this.lossRatio('close') },
    stampUrl() {
      const value = this.sysconfig && this.sysconfig.site.companyPic
      if (!value) return ''
      return resourceUrl(value)
    }
  },
  filters: { timeFilter: agreementDate },
  mounted() { this.load() },
  beforeDestroy() { this.sequence++ },
  methods: {
    numToWord(value) { return chineseAmount(value, this.mk === 2 ? '美元' : this.mk === 1 ? '港币' : '元') },
    lossRatio(kind) {
      const group = this.mk === 2 ? 'us_consult' : this.mk === 1 ? 'hk_consult' : 'consult'
      const key = (this.mk === 2 ? 'us_' : this.mk === 1 ? 'hk_' : '') + 'loss_' + kind + '_ratio'
      const value = (this.sysconfig[group] || {})[key]
      return value == null || value === '' || !Number.isFinite(Number(value)) ? '--' : 100 - parseInt(value, 10)
    },
    async load() {
      const sequence = ++this.sequence
      this.loading = true; this.failed = false; this.sysconfig = null; this.myUserInfo = null
      try {
        const [config, user] = await Promise.all([
          apiConfig({ config_keys: { site: ['company', 'companyPic'], consult: ['loss_warn_ratio', 'loss_close_ratio'], hk_consult: ['hk_loss_warn_ratio', 'hk_loss_close_ratio'], us_consult: ['us_loss_warn_ratio', 'us_loss_close_ratio'], trade: ['trade_dj', 'hk_trade_dj', 'us_trade_dj'] } }),
          apiUserInfo({})
        ])
        if (sequence !== this.sequence) return
        if (!config || !config.site || !user || typeof user !== 'object') throw new Error('Missing agreement data')
        this.sysconfig = config; this.myUserInfo = user
      } catch (_) { if (sequence === this.sequence) this.failed = true }
      finally { if (sequence === this.sequence) this.loading = false }
    }
  }
}
</script>
<style scoped>
.agreement-content { position: relative; min-height: 160px; color: var(--theme-text); font-size: 14px; line-height: 1.9; overflow-wrap: anywhere; }
.agreement-content ::v-deep .el-loading-spinner .path { stroke: var(--theme-accent); }
.agreement-text > div { margin-bottom: 20px; }
.agreement-text > div > div { margin-bottom: 14px; }
.agreement-text span { border-bottom: 1px solid var(--theme-border); }
.agreement-signatures { margin-top: 40px; }
.agreement-signature-row { display: flex; justify-content: space-between; flex-wrap: wrap; }
.agreement-company-signature { position: relative; height: 120px; display: flex; align-items: center; }
.agreement-company-signature span { display: inline-block; width: 220px; }
.agreement-user-signature span { display: inline-block; width: 200px; }
.agreement-text .company-stamp { position: absolute; z-index: 1; top: 0; right: 60px; width: 120px; height: 120px; object-fit: contain; pointer-events: none; }
.agreement-error { text-align: center; color: var(--theme-muted); }
</style>
<style>
.stock-agreement-dialog { max-width: 94vw; }
.stock-agreement-dialog .el-dialog__body { height: auto !important; max-height: 68vh; overflow-y: auto; }
</style>

